import { useTranslation } from 'next-i18next';
import { Title } from '../../';
import { GoogleRatingCard } from './google-rating.card';
/* eslint-disable-next-line */

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function GoogleRestworldRatingUI(_ref) {
  var userRatingsTotal = _ref.userRatingsTotal,
      rating = _ref.rating;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return userRatingsTotal ? /*#__PURE__*/_jsxs("div", {
    className: "flex flex-col gap-4",
    children: [/*#__PURE__*/_jsx(Title, {
      fontSize: "extraLarge",
      textColor: "bold-purple",
      content: t('common:people_trust_us'),
      isCenter: true
    }), /*#__PURE__*/_jsx(GoogleRatingCard, {
      rating: rating,
      description: "(".concat(t('common:based_on'), " ").concat(userRatingsTotal, " ").concat(t('common:reviews'), ")")
    })]
  }) : null;
}
export * from './google-rating.card';
export default GoogleRestworldRatingUI;